import { getAxiosClient } from "src/utils/axios";
import { host } from "src/config";

export const postQuestionnaire = (body) => async (dispatch, getState) => {
  const {
    auth: { userId },
  } = getState();
  const cli = getAxiosClient();
  try {
    const res = await cli.post(`/${userId}/couponlink`, body);
    return res;
  } catch (e) {
    console.log(e);
  }
};

export const postSmsCode = (body) => async (dispatch, getState) => {
  const {
    auth: { userId },
  } = getState();
  const cli = getAxiosClient();
  try {
    const res = await cli.post(`/${userId}/sms-code`, {
      ...body,
      options: {
        length: 4,
        hasCharacter: false,
        verifyCodeMessage:
          "親愛的用戶您好：\n您的驗證碼是 {{code}} , La Prairie萊珀妮感謝您。請依照步驟完成綁定。",
      },
    });
    return res;
  } catch (e) {
    console.log(e);
  }
};

export const postSmsVerify = (body) => async (dispatch, getState) => {
  const {
    auth: { userId },
  } = getState();
  const cli = getAxiosClient("postSmsVerify");
  try {
    const res = await cli.post(`/${userId}/sms-verify`, body);
    return res.data;
  } catch (e) {
    console.log(e);
    return e;
  }
};

export const getGiftForm =
  ({ userId }) =>
  async (dispatch) => {
    const cli = getAxiosClient("giftForm");
    try {
      const res = await cli.get(`/${userId}/event-form`);
      return res.data;
    } catch (e) {
      console.log(e);
      return e;
    }
  };

export const getExtraUserInfo =
  ({ userId }) =>
  async (dispatch) => {
    const cli = getAxiosClient("extraUserInfo");
    try {
      const res = await cli.get(
        `${host}/api/v1/rsvp-extra-user-info/${userId}`,
      );
      return res.data;
    } catch (e) {
      console.log(e);
      return e;
    }
  };
